<template>
  <div class="bd-index-footer" v-if="cheapTours.length > 0">
    <div>
      <div class="d-flex">
        <div class="bd-index-footer-icon">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1181_8097)">
              <path d="M20.3171 9.68255C18.9679 8.33334 17.0631 7.46033 14.9996 7.46033C12.9362 7.46033 11.0314 8.29366 9.68218 9.68255C8.33298 11.0318 7.45996 12.9365 7.45996 15C7.45996 17.0635 8.33298 18.9683 9.68218 20.3175C11.0314 21.6667 12.9362 22.5397 14.9996 22.5397C17.0631 22.5397 18.9679 21.7064 20.3171 20.3175C21.6663 18.9683 22.5393 17.0635 22.5393 15C22.5393 12.9365 21.706 11.0318 20.3171 9.68255ZM18.8885 18.8889C17.8965 19.881 16.5076 20.4762 14.9996 20.4762C13.4917 20.4762 12.1028 19.881 11.1108 18.8889C10.1187 17.8968 9.52345 16.5079 9.52345 15C9.52345 13.4921 10.1187 12.1032 11.1108 11.1111C12.1028 10.1191 13.4917 9.52382 14.9996 9.52382C16.5076 9.52382 17.8965 10.1191 18.8885 11.1111C19.8806 12.1032 20.4758 13.4921 20.4758 15C20.4758 16.5079 19.8806 17.8968 18.8885 18.8889Z" fill="white"/>
              <path d="M28.9682 13.9683H25.9126C25.3571 13.9683 24.8809 14.4445 24.8809 15C24.8809 15.5556 25.3571 16.0318 25.9126 16.0318H28.9682C29.5237 16.0318 29.9999 15.5556 29.9999 15C29.9999 14.4445 29.5237 13.9683 28.9682 13.9683Z" fill="white"/>
              <path d="M14.9995 24.881C14.444 24.881 13.9678 25.3572 13.9678 25.9127V28.9683C13.9678 29.5238 14.444 30 14.9995 30C15.5551 30 16.0313 29.5238 16.0313 28.9683V25.9127C16.0313 25.3572 15.5551 24.881 14.9995 24.881Z" fill="white"/>
              <path d="M25.5953 24.1667L23.4127 21.9841C23.0556 21.5873 22.381 21.5873 21.9841 21.9841C21.5873 22.381 21.5873 23.0159 21.9841 23.4127L24.1667 25.5953C24.5635 25.9921 25.1984 25.9921 25.5953 25.5953C25.9921 25.1984 25.9921 24.5635 25.5953 24.1667Z" fill="white"/>
              <path d="M14.9995 0C14.444 0 13.9678 0.47619 13.9678 1.03175V4.0873C13.9678 4.64286 14.444 5.11905 14.9995 5.11905C15.5551 5.11905 16.0313 4.64286 16.0313 4.0873V1.03175C16.0313 0.47619 15.5551 0 14.9995 0Z" fill="white"/>
              <path d="M25.6353 4.4048C25.2385 4.00797 24.6035 4.00797 24.2067 4.4048L22.0242 6.58734C21.6274 6.98416 21.6274 7.61908 22.0242 8.01591C22.3813 8.41273 23.0559 8.41273 23.4528 8.01591L25.6353 5.83337C26.0321 5.43654 26.0321 4.80162 25.6353 4.4048Z" fill="white"/>
              <path d="M4.0873 13.9683H1.03175C0.47619 13.9683 0 14.4445 0 15C0 15.5556 0.436508 16.0318 1.03175 16.0318H4.0873C4.64286 16.0318 5.11905 15.5556 5.11905 15C5.11905 14.4445 4.64286 13.9683 4.0873 13.9683Z" fill="white"/>
              <path d="M7.97611 21.9841C7.61897 21.5873 6.94437 21.5873 6.54754 21.9841L4.365 24.1667C3.96818 24.5635 3.96818 25.1984 4.365 25.5953C4.76183 25.9921 5.39675 25.9921 5.79357 25.5953L7.97611 23.4127C8.37294 23.0159 8.37294 22.381 7.97611 21.9841Z" fill="white"/>
              <path d="M7.97611 6.58734L5.79357 4.4048C5.39675 4.00797 4.76183 4.00797 4.365 4.4048C3.96818 4.80162 3.96818 5.43654 4.365 5.83337L6.54754 8.01591C6.94437 8.41273 7.57929 8.41273 7.97611 8.01591C8.37294 7.61908 8.37294 6.98416 7.97611 6.58734Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_1181_8097">
                <rect width="30" height="30" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <div>
          <div>Самые дешевые туры</div>
          <div><strong :class="{active: tourActive}" class="slice-hover sh-active-mode" :data-link-alt="cheapTours[getNextTourIndex()].title"><span class="sh-native" v-text="(tourActiveToggle)?cheapTours[getNextTourIndex()].title:cheapTours[activeCheapIndex].title"></span></strong></div>
        </div>
      </div>
    </div>
    <div>
      <div class="d-flex">
        <div>
          <button class="stories-trigger stories-trigger-btn slice-hover" data-link-alt="Как купить онлайн?" @click="showStories()">
            <span class="sh-native">Как купить онлайн?</span>
          </button>
        </div>
      </div>
    </div>
    <div  v-if="sales.length > 0">
      <div :class="{active: saleActive}" class="slice-hover sh-active-mode" :data-link-alt="sales[getNextSaleIndex()].message"><span class="sh-native" v-html="(saleActiveToggle)?sales[getNextSaleIndex()].message:sales[activeSaleIndex].message"></span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "header-counters",
  props: ['foundInit'],
  data() {
    return {
        cheapTours: [],
        activeCheapIndex: 0,
        tourActive: false,
        tourActiveToggle: false,
        sales: [],
        activeSaleIndex: 0,
        saleActive: false,
        saleActiveToggle: false,
        foundActive: false,
        totalToursFound: 0,
        previousTotalToursFound: 0,
    }
  },
  mounted() {
    this.getCheapTours();
    this.getSales();
    this.totalToursFound = this.foundInit
    this.previousTotalToursFound = this.foundInit
    setInterval(this.getFoundCounter, 3000)
  },
  methods: {
    showStories(){
      window.showStories();
    },
    getNextTourIndex(){
      return (this.activeCheapIndex + 1 < this.cheapTours.length)? this.activeCheapIndex+1 : 0;
    },
    getNextSaleIndex(){
      return (this.activeSaleIndex + 1 < this.sales.length)? this.activeSaleIndex+1 : 0;
    },
    getCheapTours(){
      this.axios.get('/getCheapTours').then((response)=>{
        this.cheapTours = response.data;
        setInterval(()=>{
          this.activeCheapIndex = this.getNextTourIndex()
          this.tourActive = true
          this.tourActiveToggle = false
          setTimeout(()=>{
            this.tourActive = false
            this.tourActiveToggle = false
            this.tourActiveToggle = true
          }, 500)
        }, 5000);
      })
    },
    getSales(){
      this.axios.get('/getLatestSales').then((response)=>{
        this.sales = response.data;
        setInterval(()=>{
          this.activeSaleIndex = this.getNextSaleIndex()
          this.saleActive = true
          this.saleActiveToggle = false
          setTimeout(()=>{
            this.saleActive = false
            this.saleActiveToggle = false
            this.saleActiveToggle = true
          }, 500)
        },20000);
      })
    },
    getFoundCounter(){
      this.axios.get('/getIndexCounters').then((response)=>{


        this.totalToursFound = response.data.found_tours;
        this.foundActive = true;

        setTimeout(()=>{
          this.foundActive = false;
          this.previousTotalToursFound = this.totalToursFound
        }, 1000)
      })
    }
  },
}
</script>
